/* F24 · Motor "IDEAL PARA…" compartido — 24-jul-2026
 *
 * Un solo lugar donde vive el cálculo, porque ahora se usa en TRES superficies:
 *   1. La sección grande de la PDP        (f24-pdp-ideal.liquid)
 *   2. El resumen corto en el buy box     (f24-ideal-buybox.liquid)
 *   3. El chip de las tarjetas de colección (f24-collection-promos.liquid)
 * Si el cálculo estuviera copiado en las tres, tarde o temprano dirían cosas distintas
 * del mismo producto.
 *
 * Los watts salen del KB del asesor (assets/f24-quiz-*.json) y la fórmula es la MISMA
 * que usa el quiz en need():
 *     marcha    = suma de watts en operación
 *     pico      = marcha + el mayor salto de arranque de un solo aparato
 *     requerido = max(marcha, pico)
 *     holgado   = requerido × holgura del _meta (1.2)
 *
 * Umbral para decir "sirve para esto": el PICO, no el holgado. El arranque dura
 * fracciones de segundo y la planta lo tolera; exigir 1.2× dejaría a 7 generadores
 * diciendo que no pueden con un refrigerador. El holgado se reserva para "con margen".
 */
(function(){
  'use strict';

  var ESCENARIOS = {
    generadores: [
      { id:'basica',  ico:'🔦', corto:'Emergencia',      titulo:'Emergencia básica',
        cargas:['luces','tv'],
        linea:'Luces, celulares y una pantalla. Para un apagón corto o para llevar de camping.' },
      { id:'hogar',   ico:'🏠', corto:'Hogar',           titulo:'Hogar en apagón',
        cargas:['refri','luces','tv'],
        linea:'Mantiene el <b>refrigerador</b> trabajando más luces y TV — lo mínimo para que no se te eche a perder la comida.' },
      { id:'negocio', ico:'🏪', corto:'Negocio',         titulo:'Negocio o local',
        cargas:['congelador','luces','tpv','microondas'],
        linea:'<b>Congelador comercial</b>, luces del local, caja registradora y microondas. Sigues vendiendo con la cuadra a oscuras.' },
      { id:'rancho',  ico:'🌾', corto:'Rancho',          titulo:'Rancho o campo',
        cargas:['bomba_1','rancho','luces'],
        linea:'<b>Bomba de 1 HP</b> más equipo de rancho (ordeñadora y similares) y alumbrado.' },
      { id:'casa',    ico:'🏡', corto:'Casa completa',   titulo:'Casa completa',
        cargas:['refri','luces','tv','bomba_05','microondas'],
        linea:'Refrigerador, <b>bomba de agua</b>, microondas, luces y TV al mismo tiempo. Una casa funcionando casi normal.' },
      { id:'obra',    ico:'🏗️', corto:'Obra',            titulo:'Obra y construcción',
        cargas:['sierra','herramienta','obra'],
        linea:'<b>Sierra circular o rotomartillo</b> con taladro y torres de luz. Obra sin acometida eléctrica.' },
      { id:'clima',   ico:'❄️', corto:'Local con clima', titulo:'Local con aire acondicionado',
        cargas:['minisplit','congelador','luces','tpv'],
        linea:'<b>Minisplit de 1 tonelada</b> además del congelador, luces y punto de venta. Plaza comercial o consultorio.' },
      { id:'taller',  ico:'⚡', corto:'Taller',          titulo:'Taller con soldadora',
        cargas:['soldadora','obra','herramienta'],
        linea:'<b>Soldadora</b> trabajando junto con herramienta eléctrica y alumbrado de taller.' }
    ]
  };

  var cache = {};   // kbUrl -> Promise

  function cargarKB(url){
    if(!cache[url]){
      cache[url] = fetch(url)
        .then(function(r){ return r.ok ? r.json() : null; })
        .catch(function(){ return null; });
    }
    return cache[url];
  }

  function motor(kb, familia){
    if(!kb || !kb.productos || !kb.cargas) return null;
    var C = {};
    kb.cargas.forEach(function(c){ C[c.id] = c; });
    var HOLG = (kb._meta && kb._meta.holgura) || 1.2;
    var lista = ESCENARIOS[familia] || [];

    function dimensionar(ids){
      var marcha = 0, mayorDelta = 0;
      ids.forEach(function(id){
        var c = C[id]; if(!c) return;
        marcha += c.marcha;
        var d = c.arranque - c.marcha;
        if(d > mayorDelta) mayorDelta = d;
      });
      var pico = marcha + mayorDelta;
      var req  = Math.max(marcha, pico);
      return { marcha:marcha, pico:pico, requerido:req, holgado:Math.ceil(req * HOLG) };
    }

    var porHandle = {};
    kb.productos.forEach(function(p){ porHandle[p.handle] = p; });

    return {
      /* Devuelve null si el producto no está en el KB o no trae watts — el llamador
         no debe pintar nada en ese caso, nunca un hueco. */
      para: function(handle){
        var p = porHandle[handle];
        if(!p || !p.kw) return null;
        var W = p.kw * 1000;
        var ev = lista.map(function(e){
          var d = dimensionar(e.cargas);
          return { e:e, d:d, cubre:(W >= d.requerido), margen:(W >= d.holgado) };
        });
        var cubre = ev.filter(function(x){ return x.cubre; })
                      .sort(function(a,b){ return b.d.requerido - a.d.requerido; });
        if(!cubre.length) return null;
        var falta = ev.filter(function(x){ return !x.cubre; })
                      .sort(function(a,b){ return a.d.requerido - b.d.requerido; });
        return {
          watts: W,
          mejor: cubre[0],                    // el más exigente que sí cubre
          cubre: cubre,
          primerFaltante: falta[0] || null
        };
      }
    };
  }

  window.F24Ideal = {
    /* uso: F24Ideal.motor(kbUrl, 'generadores').then(function(m){ m.para(handle) }) */
    motor: function(kbUrl, familia){
      return cargarKB(kbUrl).then(function(kb){ return motor(kb, familia); });
    },
    escenarios: ESCENARIOS
  };
})();
